import React from "react";
import { Container, Box, Grid, GridItem, Text } from "@chakra-ui/react";
import AllcoursesApi from "./allcourseapi";
import Card from "../Card";
import Arrow from "../arrow";
import Styles from "./MyCourse.module.css"

const AllCourses = () => {
  return (
    <Container maxW="100%" bgColor="white" marginLeft="0px">
      <Grid marginLeft="0px" className={Styles?.courseContainer} display={"flex"}>
        {AllcoursesApi.map((value, index) => {
          return (
            <GridItem key={index} marginBottom="5px">
              <Card
                key={index}
                imgsrc={value.imgsrc}
                title={value.title}
                profile={value.profile}
                name={value.name}
              />
            </GridItem>
          );
        })}
      </Grid>
    </Container>
  );
};

export default AllCourses;
